module.exports = __webpack_public_path__ + "img/gyrosicon.c6fa44f6.png";